/**
 * Guard against open redirects for post-login return targets.
 *
 * A `next` value travels through the login flow (query string, Google OAuth,
 * magic-link email) and is used to redirect the browser after authentication.
 * Only app-internal absolute paths are allowed: an absolute URL,
 * protocol-relative `//host`, or a `/\` backslash trick could bounce a trusted
 * login to an attacker origin, so those are rejected (caller falls back to a
 * safe default).
 */
export function safeReturnPath(next: string | null | undefined): string | null {
  if (!next) return null;
  if (!next.startsWith('/')) return null;
  if (next.startsWith('//') || next.startsWith('/\\')) return null;
  return next;
}
